/*
  km-gelaender.js · Kirchberger Metall · 10.09.2026
  Geländer-Konfigurator (Regelwerk typ "gelaender"): Zustand, Sichtbarkeit, Preis,
  Schrittfolge, Skizzen-Upload, Warenkorb, Angebotsanfrage.

  Eigenständig gegenüber km-konfigurator.js / -schritte.js / -anfrage.js (Balkone,
  Fenstergitter): dort ist Breite × Höhe je Stück verdrahtet, hier zählt die Fläche aus
  bis zu drei Seiten (oder der Gesamtlänge einer Sonderform) mal Höhe, der Preis je m²
  ist nach Fläche gestaffelt. Preislogik: kmGelaenderPreis / kmGelaenderPruefen unten -
  wortgleich mit der Cart-Transform-Function, die beim Checkout verbindlich nachrechnet.

  Warenkorb: eine Position, Property-Schlüssel = K3-Merkmalsnamen, dazu _km_konfig
  (base64-JSON), aus dem die Function rechnet und die lesbaren Merkmale neu setzt.
*/
(function () {
  'use strict';

  /* ================= Preislogik (identisch in der Function) ================= */
  function kmGelaenderPreis(rules, k) {
    function num(v) { var n = Number(v); return isNaN(n) ? 0 : n; }
    function findeId(list, id) { for (var i = 0; i < (list || []).length; i++) if (list[i].id === id) return list[i]; return null; }
    var geo = findeId(rules.geometrie.optionen, k.g);
    var mat = findeId(rules.material.optionen, k.m);
    var hl = findeId(rules.handlauf.optionen, k.hl);
    var set = findeId(rules.sets.optionen, k.st);
    if (!geo || !mat || !hl || !set) return null;
    var laengen = [];
    if (geo.laengen >= 1) laengen.push(num(k.l1));
    if (geo.laengen >= 2) laengen.push(num(k.l2));
    if (geo.laengen >= 3) laengen.push(num(k.l3));
    var gesamt = geo.skizze ? num(k.lg) : 0;
    for (var i = 0; i < laengen.length; i++) gesamt += laengen[i];
    var hoehe = num(k.h);
    var flaeche = Math.round(gesamt * hoehe) / 1e6;
    var grenzen = rules.flaeche.staffel_bis_m2;
    var s = grenzen.length;
    for (var j = 0; j < grenzen.length; j++) { if (flaeche < grenzen[j]) { s = j; break; } }
    var satzMaterial = num(mat.staffel[s]);
    var satzHandlauf = (hl.id === 'ohne') ? 0 : num(rules.handlauf.staffel[s]);
    var satzSet = num(set.preis_qm);
    // Glasfuellung (nur Modelle mit Glas, heute Vista) - Aufpreis je m2 Gelaenderflaeche,
    // gestaffelt wie der Rahmen. Regelwerke ohne "glas" bleiben unveraendert bei 0.
    var glasOpt = null;
    if (rules.glas && rules.glas.optionen) {
      for (var gi = 0; gi < rules.glas.optionen.length; gi++) {
        if (rules.glas.optionen[gi].id === k.glas) { glasOpt = rules.glas.optionen[gi]; break; }
      }
      if (!glasOpt) glasOpt = rules.glas.optionen[0];
    }
    var satzGlas = glasOpt ? num(glasOpt.preis_qm) : 0;
    var satz = satzMaterial + satzHandlauf + satzSet + satzGlas;
    return {
      gesamt_mm: gesamt, hoehe_mm: hoehe, flaeche: flaeche, staffel: s,
      satz_material: satzMaterial, satz_handlauf: satzHandlauf, satz_set: satzSet, satz_glas: satzGlas, satz: satz,
      material: Math.round(flaeche * satzMaterial * 100) / 100,
      handlauf: Math.round(flaeche * satzHandlauf * 100) / 100,
      set: Math.round(flaeche * satzSet * 100) / 100,
      glas: Math.round(flaeche * satzGlas * 100) / 100,
      preis: Math.round(flaeche * satz * 100) / 100
    };
  }
  function kmGelaenderPruefen(rules, k) {
    function num(v) { var n = Number(v); return isNaN(n) ? 0 : n; }
    function findeId(list, id) { for (var i = 0; i < (list || []).length; i++) if (list[i].id === id) return list[i]; return null; }
    var fehler = [];
    var geo = findeId(rules.geometrie.optionen, k.g);
    if (!geo) { fehler.push('geometrie'); return fehler; }
    var h = num(k.h);
    if (h < rules.hoehe.min || h > rules.hoehe.max) fehler.push('hoehe');
    var L = rules.laengen, summe = 0;
    var werte = [k.l1, k.l2, k.l3];
    for (var i = 0; i < geo.laengen; i++) {
      var v = num(werte[i]);
      var minI = (i === 0) ? L.min : (L.min_folge != null ? L.min_folge : L.min);
      if (v < minI || v > L.max || (i > 0 && v > 0 && v < L.min)) fehler.push('laenge' + (i + 1));
      summe += v;
    }
    if (geo.skizze) {
      var lg = num(k.lg);
      if (lg < (L.gesamt_min || L.min) || lg > L.gesamt_max) fehler.push('gesamt');
      summe += lg;
      if (!k.sk) fehler.push('skizze');
    }
    if (summe > L.gesamt_max) fehler.push('gesamt_max');
    if (L.gesamt_min && summe < L.gesamt_min) fehler.push('gesamt_min');
    var M = rules.masse;
    if (M) {
      var e = num(k.e), z = num(k.z), y = num(k.y);
      if (e < M.e.min || e > M.e.max) fehler.push('e');
      if (z < M.z.min || z > M.z.max) fehler.push('z');
      if (y < M.y.min || y > M.y.max) fehler.push('y');
    }
    var mat = findeId(rules.material.optionen, k.m);
    if (mat && mat.farbe) {
      if (!k.f) fehler.push('farbe');
      else {
        var wahl = null;
        for (var f = 0; f < rules.farbe.optionen.length; f++) if (rules.farbe.optionen[f].label === k.f) wahl = rules.farbe.optionen[f];
        if (!wahl) fehler.push('farbe');
        else if (wahl.wahl && !String(k.fw || '').trim()) fehler.push('farbe_wunsch');
      }
    }
    return fehler;
  }

  /* ================= Konfigurator ================= */
  function init(root) {
    var sid = root.getAttribute('data-section-id');
    var rulesEl = document.getElementById('km-rules-' + sid);
    var ctxEl = document.getElementById('km-ctx-' + sid);
    var imgEl = document.getElementById('km-images-' + sid);
    var form = document.getElementById('km-form-' + sid);
    if (!rulesEl || !ctxEl || !form) return;
    var R = JSON.parse(rulesEl.textContent);
    var CTX = JSON.parse(ctxEl.textContent);
    var IMG = imgEl ? JSON.parse(imgEl.textContent) : {};
    var MEDIA = IMG.media || {};
    var MEDIA_URL = IMG.media_url || {};

    var TAXF = (function () {
      var st = R.steuer; if (!st || !st.saetze || !CTX.country) return 1;
      var satz = st.saetze[CTX.country]; if (satz === undefined || satz === null) return 1;
      return (100 + Number(satz)) / (100 + Number(st.basissatz || 19));
    })();
    var TAXSATZ = (function () {
      var st = R.steuer; if (!st || !st.saetze || !CTX.country) return null;
      var satz = st.saetze[CTX.country]; return (satz === undefined || satz === null) ? null : Number(satz);
    })();

    var els = {
      total: document.getElementById('km-total-' + sid),
      netto: document.getElementById('km-netto-' + sid),
      liste: document.getElementById('km-liste-' + sid),
      flag: document.getElementById('km-flag-' + sid),
      add: document.getElementById('km-add-' + sid),
      quote: document.getElementById('km-quote-' + sid),
      msg: document.getElementById('km-msg-' + sid),
      offen: document.getElementById('km-offen-' + sid),
      leiste: document.getElementById('km-fortschritt-' + sid)
    };

    function fmt(n) { return n.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'; }
    function fmtM(n, d) { return n.toLocaleString('de-DE', { minimumFractionDigits: d, maximumFractionDigits: d }); }
    function esc(t) { return String(t == null ? '' : t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
    function clamp(v, min, max) { v = Number(v); if (isNaN(v)) v = min; return Math.min(max, Math.max(min, v)); }
    function findeId(list, id) { for (var i = 0; i < (list || []).length; i++) if (list[i].id === id) return list[i]; return null; }
    function wert(name) {
      var el = form.elements[name]; if (!el) return '';
      if (el.length && el[0] && el[0].type === 'radio') { for (var i = 0; i < el.length; i++) if (el[i].checked) return el[i].value; return ''; }
      return el.value;
    }
    function setWert(name, v) {
      var el = form.elements[name]; if (!el || v == null) return;
      if (el.length && el[0] && el[0].type === 'radio') {
        var treffer = false;
        for (var i = 0; i < el.length; i++) if (el[i].value === String(v)) treffer = true;
        if (!treffer) return;
        for (var j = 0; j < el.length; j++) el[j].checked = (el[j].value === String(v));
      } else el.value = v;
    }

    // --- Zustand ---
    function state() {
      var s = {
        m: wert('material'), f: wert('farbe'), fw: (wert('farbe_wunsch') || '').trim(),
        glas: wert('glas'),
        bf: wert('befestigung'), g: wert('geometrie'),
        h: Number(wert('hoehe')), l1: Number(wert('l1')), l2: Number(wert('l2')), l3: Number(wert('l3')), lg: Number(wert('lg')),
        sk: (wert('skizze_url') || '').trim(), skn: (wert('skizze_name') || '').trim(),
        hl: wert('handlauf'), e: Number(wert('e')), z: Number(wert('z')), y: Number(wert('y')),
        st: wert('set'), bm: (wert('bemerkung') || '').trim()
      };
      s.mat = findeId(R.material.optionen, s.m);
      s.geo = findeId(R.geometrie.optionen, s.g);
      s.bef = findeId(R.befestigung.optionen, s.bf);
      s.hlo = findeId(R.handlauf.optionen, s.hl);
      s.set = findeId(R.sets.optionen, s.st);
      // Glasfuellung nur bei Modellen, deren Regelwerk eine Glasliste fuehrt (heute Vista)
      s.glaso = R.glas && R.glas.optionen ? findeId(R.glas.optionen, s.glas) : null;
      s.fehlt = [];
      if (!s.mat) s.fehlt.push({ schritt: 'material', label: R.material.label });
      if (!s.bef) s.fehlt.push({ schritt: 'befestigung', label: R.befestigung.label });
      if (!s.geo) s.fehlt.push({ schritt: 'masse', label: R.geometrie.label });
      if (!s.hlo) s.fehlt.push({ schritt: 'handlauf', label: R.handlauf.label });
      if (!s.set) s.fehlt.push({ schritt: 'sets', label: R.sets.label });
      if (R.glas && !s.glaso) s.fehlt.push({ schritt: 'glas', label: R.glas.label });
      if (s.mat && s.mat.farbe && !s.f) s.fehlt.push({ schritt: 'material', label: R.farbe.label });
      return s;
    }
    function istWunschfarbe(s) {
      if (!s.mat || !s.mat.farbe || !s.f) return false;
      for (var i = 0; i < R.farbe.optionen.length; i++) if (R.farbe.optionen[i].label === s.f) return !!R.farbe.optionen[i].wahl;
      return false;
    }
    function farbText(s) {
      if (!s.mat || !s.mat.farbe || !s.f) return '';
      return istWunschfarbe(s) && s.fw ? s.fw + ' (Wunschfarbe)' : s.f;
    }

    // --- Sichtbarkeit ---
    function sichtbarkeit(s) {
      var farbFeld = root.querySelector('[data-show-if="farbe"]');
      if (farbFeld) farbFeld.hidden = !(s.mat && s.mat.farbe);
      var wunsch = root.querySelector('[data-farbe-wunsch]');
      if (wunsch) wunsch.hidden = !istWunschfarbe(s);
      var n = s.geo ? s.geo.laengen : 1;
      for (var i = 1; i <= 3; i++) {
        var fs = root.querySelector('[data-laenge="' + i + '"]');
        if (fs) fs.hidden = i > n;
      }
      var sonder = !!(s.geo && s.geo.skizze);
      var ges = root.querySelector('[data-gesamt]'); if (ges) ges.hidden = !sonder;
      var skz = root.querySelector('[data-skizze]'); if (skz) skz.hidden = !sonder;
    }

    // --- Fehlertexte ---
    var FEHLER = {
      hoehe: function () { return 'Bitte einen Wert zwischen ' + R.hoehe.min + ' und ' + R.hoehe.max + ' mm eingeben.'; },
      laenge1: function () { return 'Bitte einen Wert zwischen ' + R.laengen.min + ' und ' + R.laengen.max + ' mm eingeben.'; },
      laenge2: function () { return 'Bitte 0 (keine Seite) oder einen Wert zwischen ' + R.laengen.min + ' und ' + R.laengen.max + ' mm eingeben.'; },
      laenge3: function () { return 'Bitte 0 (keine Seite) oder einen Wert zwischen ' + R.laengen.min + ' und ' + R.laengen.max + ' mm eingeben.'; },
      gesamt: function () { return 'Bitte die Gesamtlänge zwischen ' + (R.laengen.gesamt_min || R.laengen.min) + ' und ' + R.laengen.gesamt_max + ' mm eingeben.'; },
      gesamt_max: function () { return 'Insgesamt sind bis ' + (R.laengen.gesamt_max / 1000) + ' m möglich – für längere Geländer fordern Sie bitte ein Angebot an.'; },
      gesamt_min: function () { return 'Insgesamt mindestens ' + (R.laengen.gesamt_min) + ' mm.'; },
      skizze: function () { return 'Für eine Sonderform brauchen wir Ihre Skizze – bitte oben hochladen.'; },
      e: function () { return 'Bitte einen Wert zwischen ' + R.masse.e.min + ' und ' + R.masse.e.max + ' mm eingeben.'; },
      z: function () { return 'Bitte einen Wert zwischen ' + R.masse.z.min + ' und ' + R.masse.z.max + ' mm eingeben.'; },
      y: function () { return 'Bitte einen Wert zwischen ' + R.masse.y.min + ' und ' + R.masse.y.max + ' mm eingeben.'; },
      farbe: function () { return 'Bitte eine Farbe wählen.'; },
      farbe_wunsch: function () { return 'Bitte nennen Sie den gewünschten Farbton, z. B. RAL 6005.'; }
    };
    var FELD = { hoehe: 'hoehe', laenge1: 'l1', laenge2: 'l2', laenge3: 'l3', gesamt: 'lg', gesamt_max: 'l1', gesamt_min: 'l1', skizze: 'skizze', e: 'e', z: 'z', y: 'y', farbe: 'farbe', farbe_wunsch: 'farbe' };
    function fehlerAnzeigen(fehler) {
      root.querySelectorAll('.km-f__err[data-err]').forEach(function (p) { p.hidden = true; p.textContent = ''; });
      var gesetzt = {};
      fehler.forEach(function (f) {
        var feld = FELD[f]; if (!feld || gesetzt[feld]) return;
        var p = root.querySelector('.km-f__err[data-err="' + feld + '"]');
        if (!p) return;
        p.textContent = FEHLER[f] ? FEHLER[f]() : 'Bitte prüfen.';
        p.hidden = false; gesetzt[feld] = true;
      });
    }

    // --- Galerie: Rendering je Befestigung × Geometrie × Handlauf (wie K3) ---
    // Schlüssel in custom.km_medien: "aufgesetzt|l|mit" (Handlauf gewählt) bzw. "…|ohne";
    // Rückfall auf "aufgesetzt|l" und "aufgesetzt". Solange kein Handlauf gewählt ist, zeigt
    // die Galerie die Ausführung ohne Handlauf.
    var galerieBereit = false, aktuellerKey = null;
    // Bildwechsel ohne Durchblättern: Focal fährt beim Thumbnail-Klick animiert über alle
    // Zwischenbilder (bei 16 Renderings + Skizzen "rattert" die Galerie). Deshalb direkt an
    // Flickity mit isInstant = true; Focal setzt das aktive Thumbnail über das select-Event.
    function selectMedia(id) {
      var item = document.querySelector('.product__media-item[data-media-id="' + id + '"]');
      var car = document.querySelector('flickity-carousel.product__media-list, .product__media-list');
      var thumb = document.querySelector('.product__thumbnail-item[data-media-id="' + id + '"]');
      var fallback = function () { if (thumb) thumb.click(); };
      if (!item || !car) { fallback(); return; }
      var inst = car.flickityInstance || (window.Flickity && window.Flickity.data(car));
      if (!inst) { fallback(); return; }
      Promise.resolve(inst).then(function (f) {
        if (f && typeof f.selectCell === 'function') f.selectCell(item, false, true); else fallback();
      }).catch(fallback);
    }
    function renderKey(s) {
      if (!s.bf) return null;
      var hl = (s.hl && s.hl !== 'ohne') ? 'mit' : 'ohne';
      var kandidaten = [];
      if (s.g) { kandidaten.push(s.bf + '|' + s.g + '|' + hl); kandidaten.push(s.bf + '|' + s.g); }
      kandidaten.push(s.bf);
      for (var i = 0; i < kandidaten.length; i++) if (MEDIA[kandidaten[i]]) return kandidaten[i];
      return null;
    }
    function showRender(s) {
      var key = renderKey(s);
      if (!key || key === aktuellerKey) return;
      aktuellerKey = key;
      if (!galerieBereit) return;
      selectMedia(MEDIA[key]);
    }
    // Die Renderings sollen nicht als 16 zusätzliche Thumbnails in der Galerie stehen -
    // sie erscheinen nur über die Konfiguration (wie in K3).
    function renderThumbsVerstecken() {
      Object.keys(MEDIA).forEach(function (k) {
        var t = document.querySelector('.product__thumbnail-item[data-media-id="' + MEDIA[k] + '"]');
        if (t) t.classList.add('km-render-thumb');
      });
    }
    // Klick ins Maßfeld E/Z/Y: Detailskizze zur gewählten Befestigung in der Galerie zeigen
    // (Schlüssel "skizze|<feld>|<befestigung>"). Das Rendering kommt zurück, sobald sich
    // Form, Befestigung oder Handlauf ändern (showRender vergleicht nur seinen eigenen Key).
    function skizzeZeigen(feld) {
      var bf = wert('befestigung') || 'aufgesetzt';
      var id = MEDIA['skizze|' + feld + '|' + bf];
      if (!id || !galerieBereit) return;
      // Das Rendering gilt als "gezeigt": weitere Eingaben springen nicht zurück,
      // erst ein Wechsel von Form, Befestigung oder Handlauf holt es wieder.
      aktuellerKey = renderKey(state());
      selectMedia(id);
    }

    // --- Deep-Link ---
    function konfig(s) {
      // Nur die Maße mitgeben, die zur gewählten Form gehören - versteckte Felder behalten
      // sonst alte Werte und würden im Auftrag und in der Function mitlaufen.
      var n = s.geo ? s.geo.laengen : 1, sonder = !!(s.geo && s.geo.skizze);
      return {
        t: 'g', m: s.m, f: s.f, fw: s.fw, bf: s.bf, g: s.g, h: s.h,
        l1: n >= 1 ? s.l1 : 0, l2: n >= 2 ? s.l2 : 0, l3: n >= 3 ? s.l3 : 0, lg: sonder ? s.lg : 0,
        glas: s.glas, hl: s.hl, e: s.e, z: s.z, y: s.y, st: s.st, bm: s.bm, sk: sonder ? s.sk : '', skn: sonder ? s.skn : ''
      };
    }
    function encode(s) {
      return btoa(unescape(encodeURIComponent(JSON.stringify(konfig(s))))).replace(/=+$/, '');
    }
    function decode(str) { try { return JSON.parse(decodeURIComponent(escape(atob(str)))); } catch (e) { return null; } }
    var nutzerAendert = false; // Deep-Link erst schreiben, wenn der Besucher etwas geaendert hat
    var linkTimer = null;
    function deepLink(s) {
      if (!nutzerAendert) return;
      if (linkTimer) clearTimeout(linkTimer);
      linkTimer = setTimeout(function () {
        linkTimer = null;
        try { history.replaceState(null, '', location.pathname + location.search + '#konf=' + encode(s)); } catch (e) {}
      }, 500);
    }
    var wechselLinks = root.querySelectorAll('[data-km-material][data-km-basis]');
    function wechselAktualisieren(s) {
      for (var i = 0; i < wechselLinks.length; i++) {
        var a = wechselLinks[i];
        var kopie = state(); kopie.m = a.getAttribute('data-km-material');
        a.setAttribute('href', a.getAttribute('data-km-basis') + '#konf=' + encode(kopie));
      }
    }

    // --- Warenkorb-Properties (Schlüssel = K3-Merkmalsnamen) ---
    function properties(s, p) {
      var props = {};
      props[R.familie_key] = R.modell;
      props[R.material.key] = s.mat.label;
      if (R.glas && s.glaso) props[R.glas.key] = s.glaso.label;
      if (s.mat.farbe && s.f) props[R.farbe.key] = farbText(s);
      props[R.befestigung.key] = s.bef.label;
      props[R.geometrie.key] = s.geo.label;
      props[R.hoehe.key] = s.h + ' mm';
      for (var i = 0; i < s.geo.laengen; i++) props[R.laengen.keys[i]] = [s.l1, s.l2, s.l3][i] + ' mm';
      if (s.geo.skizze) {
        props[R.laengen.gesamt_key] = s.lg + ' mm';
        props[R.skizze.key] = s.sk;
      } else {
        props[R.laengen.gesamt_key] = p.gesamt_mm + ' mm';
      }
      props[R.handlauf.key] = s.hlo.label;
      props[R.masse.e.key] = s.e + ' mm';
      props[R.masse.z.key] = s.z + ' mm';
      props[R.masse.y.key] = s.y + ' mm';
      props[R.sets.key] = s.set.label;
      if (R.fertigungsstart_text) props['Fertigungsstart'] = R.fertigungsstart_text;
      if (s.bm) props[R.bemerkung.key] = s.bm;
      var bildKey = renderKey(s), bildId = bildKey ? MEDIA[bildKey] : null;
      var bildUrl = bildId ? MEDIA_URL[bildId] : (CTX.bild || null);
      if (bildUrl) props['_km_bild'] = bildUrl;
      props['_km_preis'] = p.preis.toFixed(2);
      props['_km_flaeche'] = p.flaeche.toFixed(3);
      // 19.09.2026: Klartext-JSON statt base64 (wie Koeln/Vordach). Der base64-Dekoder der
      // Function kostete in QuickJS bei langen Bemerkungen mehr als das Instruktionsbudget -
      // Bestellung #1604 ging deshalb zum Variantenpreis durch. Deep-Link (#konf=) bleibt base64.
      props['_km_konfig'] = JSON.stringify(konfig(s));
      return props;
    }

    // --- Handlauf-Preise in den Karten (je Staffel) ---
    function handlaufPreise(p) {
      var satz = p ? R.handlauf.staffel[p.staffel] : R.handlauf.staffel[0];
      root.querySelectorAll('[data-handlaufpreis]').forEach(function (el) { el.textContent = '+ ' + fmt(Number(satz)) + ' je m²'; });
    }

    // --- Anzeige ---
    function update() {
      var s = state();
      sichtbarkeit(s);
      var fehler = (s.fehlt.length ? [] : kmGelaenderPruefen(R, s));
      fehlerAnzeigen(fehler);
      var ok = !s.fehlt.length && !fehler.length;
      var p = (s.mat && s.geo && s.hlo && s.set) ? kmGelaenderPreis(R, s) : null;
      handlaufPreise(p);
      showRender(s);

      var total = p ? Math.round(p.preis * TAXF * 100) / 100 : 0;
      els.total.textContent = (ok && p) ? fmt(total) : '–';
      if (els.netto) {
        if (ok && p && TAXSATZ !== null && TAXSATZ > 0) {
          var nbsp = String.fromCharCode(160);
          els.netto.textContent = fmt(total / (1 + TAXSATZ / 100)) + nbsp + 'netto zzgl.' + nbsp + TAXSATZ + nbsp + '%' + nbsp + 'MwSt.';
          els.netto.hidden = false;
        } else els.netto.hidden = true;
      }
      if (els.liste) {
        var zeilen = [];
        function zeile(bez, betrag, klasse) {
          zeilen.push('<li class="km-pos' + (klasse ? ' ' + klasse : '') + '"><span class="km-pos__bez">' + esc(bez) + '</span><span class="km-pos__wert">' + esc(betrag) + '</span></li>');
        }
        if (ok && p) {
          var f = function (x) { return Math.round(x * TAXF * 100) / 100; };
          zeile('Geländer ' + R.modell + ', ' + s.mat.label + ' · ' + fmtM(p.gesamt_mm / 1000, 2) + ' m × ' + s.h + ' mm = ' + fmtM(p.flaeche, 2) + ' m² · ' + fmt(f(p.satz_material)) + '/m²', fmt(f(p.material)));
          zeile('Form: ' + s.geo.label + ' · Befestigung: ' + s.bef.label, 'inkl.');
          if (s.mat.farbe && s.f) zeile('Farbe: ' + farbText(s), 'inkl.');
          if (R.glas && s.glaso) {
            if (p.satz_glas > 0) zeile(R.glas.label + ': ' + s.glaso.label + ' · ' + fmt(f(p.satz_glas)) + '/m²', fmt(f(p.glas)));
            else zeile(R.glas.label + ': ' + s.glaso.label, 'ohne');
          }
          if (p.satz_handlauf > 0) zeile('Handlauf: ' + s.hlo.label + ' · ' + fmt(f(p.satz_handlauf)) + '/m²', fmt(f(p.handlauf)));
          else zeile('Handlauf: ' + s.hlo.label, 'inkl.');
          if (p.satz_set > 0) zeile('Befestigungsmaterial: ' + s.set.label + ' · ' + fmt(f(p.satz_set)) + '/m²', fmt(f(p.set)));
          else zeile('Befestigungsmaterial: ' + s.set.label, 'ohne');
          zeile('Maßzeichnung zur Freigabe vor der Fertigung', 'inkl.');
        } else {
          zeile('Geländer (Angaben prüfen)', '–');
        }
        els.liste.innerHTML = zeilen.join('');
      }
      if (els.flag) els.flag.hidden = !(R.preis_status === 'vorlaeufig');
      if (els.add) {
        els.add.classList.toggle('km-btn--gesperrt', !ok);
        els.add.setAttribute('aria-disabled', ok ? 'false' : 'true');
      }
      if (els.msg) {
        if (s.fehlt.length) {
          els.msg.textContent = 'Bitte treffen Sie noch eine Auswahl: ' + s.fehlt.map(function (x) { return x.label; }).join(', ') + '.';
          els.msg.className = 'km-msg is-err'; els.msg.setAttribute('data-km-auswahl', '1');
        } else if (els.msg.getAttribute('data-km-auswahl')) {
          els.msg.textContent = ''; els.msg.className = 'km-msg'; els.msg.removeAttribute('data-km-auswahl');
        }
      }
      wechselAktualisieren(s);
      deepLink(s);
      schritteZeichnen(s, ok, fehler);
      return { s: s, p: p, ok: ok, fehler: fehler, total: total };
    }

    /* ================= Schrittfolge (Akkordeon + Leiste) ================= */
    var schritte = [].slice.call(root.querySelectorAll('.km-step'));
    var beruehrt = {};
    var FELD_SCHRITT = { material: 'material', farbe: 'material', farbe_wunsch: 'material', glas: 'glas', befestigung: 'befestigung', geometrie: 'masse', hoehe: 'masse', l1: 'masse', l2: 'masse', l3: 'masse', lg: 'masse', skizze_datei: 'masse', e: 'montage', z: 'montage', y: 'montage', handlauf: 'handlauf', set: 'sets' };
    var HINWEIS = { glas: 'Mit oder ohne Glasfüllung?', befestigung: 'Aufgesetzt oder vorgesetzt?', masse: 'Bitte Form wählen und Maße eintragen', montage: 'Bitte E, Z und Y prüfen', handlauf: 'Bitte Handlauf wählen', sets: 'Bitte Befestigungsmaterial wählen' };
    function haken(px) {
      return '<svg viewBox="0 0 24 24" width="' + px + '" height="' + px + '" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M4 12.5 9.5 18 20 6.5"/></svg>';
    }
    function hatAuswahl(schritt) {
      var koerper = schritt.querySelector('.km-step__body'); if (!koerper) return false;
      var offen = function (el) { var n = el; while (n && n !== koerper) { if (n.hidden) return false; n = n.parentElement; } return true; };
      var gruppen = {};
      koerper.querySelectorAll('input[type="radio"]').forEach(function (r) { if (offen(r)) gruppen[r.name] = (gruppen[r.name] || 0) + 1; });
      for (var g in gruppen) if (gruppen[g] > 1) return true;
      var felder = koerper.querySelectorAll('input[type="number"], input[type="text"]');
      for (var k = 0; k < felder.length; k++) if (offen(felder[k])) return true;
      return false;
    }
    function wertText(name, s) {
      if (name === 'material') { var t = s.mat ? s.mat.label : ''; if (s.mat && s.mat.farbe && s.f) t += ' · ' + farbText(s); return t; }
      if (name === 'befestigung') return s.bef ? s.bef.label : '';
      if (name === 'masse') {
        if (!s.geo) return '';
        var p = kmGelaenderPreis(R, s);
        var teile = [];
        if (s.geo.skizze) teile.push(s.lg + ' mm gesamt'); else { for (var i = 0; i < s.geo.laengen; i++) { var v = [s.l1, s.l2, s.l3][i]; if (v) teile.push(v); } }
        return s.geo.label.replace(/ - .*$/, '') + ' · ' + (s.geo.skizze ? teile[0] : teile.join(' + ') + ' mm') + ' × ' + s.h + ' mm' + (p ? ' = ' + fmtM(p.flaeche, 2) + ' m²' : '');
      }
      if (name === 'montage') return 'E ' + s.e + ' · Z ' + s.z + ' · Y ' + s.y + ' mm';
      if (name === 'glas') return s.glaso ? s.glaso.label : '';
      if (name === 'handlauf') return s.hlo ? s.hlo.label : '';
      if (name === 'sets') return s.set ? s.set.label : '';
      return '';
    }
    function erledigt(schritt, name, s, ok, fehler) {
      if (name === 'masse') {
        if (!beruehrt.masse) return false;
        var f = ['hoehe', 'laenge1', 'laenge2', 'laenge3', 'gesamt', 'gesamt_max', 'gesamt_min', 'skizze'];
        for (var i = 0; i < f.length; i++) if (fehler.indexOf(f[i]) >= 0) return false;
        return true;
      }
      if (name === 'montage') {
        if (!beruehrt.montage) return false;
        return fehler.indexOf('e') < 0 && fehler.indexOf('z') < 0 && fehler.indexOf('y') < 0;
      }
      if (name === 'material' && (fehler.indexOf('farbe') >= 0 || fehler.indexOf('farbe_wunsch') >= 0)) return false;
      if (!wertText(name, s)) return false;
      return !!beruehrt[name] || !hatAuswahl(schritt);
    }
    function aufklappen(schritt, auf, merken) {
      var knopf = schritt.querySelector('.km-step__toggle'), koerper = schritt.querySelector('.km-step__body');
      knopf.setAttribute('aria-expanded', auf ? 'true' : 'false'); koerper.hidden = !auf;
      schritt.classList.toggle('is-offen', auf);
      if (auf && merken !== false) { var name = schritt.getAttribute('data-step'); if (name && name !== 'masse') beruehrt[name] = true; }
    }
    function aktive() { for (var i = 0; i < schritte.length; i++) if (schritte[i].classList.contains('is-offen')) return schritte[i]; return null; }
    var letzterStand = { s: null, ok: false, fehler: [] };
    function naechsterOffener(ab) {
      var start = ab ? schritte.indexOf(ab) + 1 : 0;
      for (var i = start; i < schritte.length; i++) if (!erledigt(schritte[i], schritte[i].getAttribute('data-step'), letzterStand.s, letzterStand.ok, letzterStand.fehler)) return schritte[i];
      for (var j = start; j < schritte.length; j++) return schritte[j];
      return null;
    }
    function schritteZeichnen(s, ok, fehler) {
      letzterStand = { s: s, ok: ok, fehler: fehler };
      var nr = 0, offeneNamen = [], punkte = '', ersterOffenNr = 0;
      schritte.forEach(function (schritt) {
        var name = schritt.getAttribute('data-step');
        nr += 1;
        var fertig = erledigt(schritt, name, s, ok, fehler);
        if (!fertig) { offeneNamen.push(schritt.querySelector('.km-step__titel').textContent.trim()); if (!ersterOffenNr) ersterOffenNr = nr; }
        schritt.querySelector('.km-step__nr').textContent = nr;
        var wahl = schritt.querySelector('.km-step__wahl');
        var hinweis = !!HINWEIS[name] && !beruehrt[name] && (name === 'masse' ? true : hatAuswahl(schritt));
        wahl.textContent = hinweis ? HINWEIS[name] : wertText(name, s);
        wahl.classList.toggle('is-hinweis', hinweis);
        schritt.classList.toggle('is-fertig', fertig);
        var status = schritt.querySelector('[data-step-status]');
        status.className = 'km-step__status ' + (fertig ? 'is-fertig' : 'is-offen');
        status.innerHTML = fertig ? haken(13) : '';
        punkte += '<span class="km-fortschritt__punkt' + (fertig ? ' is-fertig' : '') + '">' + (fertig ? haken(11) : nr) + '</span>';
      });
      if (els.leiste) {
        var text = els.leiste.querySelector('[data-fortschritt-text]');
        var pk = els.leiste.querySelector('[data-fortschritt-punkte]');
        var weiter = els.leiste.querySelector('[data-fortschritt-weiter]');
        if (text) text.textContent = offeneNamen.length === 0 ? 'Alle ' + nr + ' Schritte erledigt' : 'Schritt ' + ersterOffenNr + ' von ' + nr;
        if (pk) pk.innerHTML = punkte;
        if (weiter) weiter.hidden = offeneNamen.length === 0;
      }
      if (els.offen) {
        if (offeneNamen.length) { els.offen.textContent = 'Noch offen: ' + offeneNamen.join(', '); els.offen.hidden = false; }
        else els.offen.hidden = true;
      }
    }
    schritte.forEach(function (schritt) {
      schritt.querySelector('.km-step__toggle').addEventListener('click', function () {
        var war = schritt.classList.contains('is-offen');
        var vorher = schritt.getBoundingClientRect().top;
        schritte.forEach(function (x) { aufklappen(x, false); });
        aufklappen(schritt, !war);
        update();
        var diff = schritt.getBoundingClientRect().top - vorher;
        if (Math.abs(diff) > 2) window.scrollBy(0, diff);
      });
    });
    if (els.leiste) {
      var weiterKnopf = els.leiste.querySelector('[data-fortschritt-weiter]');
      if (weiterKnopf) weiterKnopf.addEventListener('click', function () {
        var ziel = naechsterOffener(aktive()) || naechsterOffener(null); if (!ziel) return;
        schritte.forEach(function (x) { aufklappen(x, false); }); aufklappen(ziel, true); update();
        ziel.scrollIntoView({ block: 'center', behavior: 'smooth' });
      });
      // 19.09.2026: Leiste steht seit 07.09. fest ueber dem ersten Schritt (position: static).
      // Der fruehere IntersectionObserver (Ein-/Ausblenden je nach Sichtbarkeit des Formulars)
      // liess das Formular beim Scrollen um die Leistenhoehe springen - deshalb immer sichtbar.
      els.leiste.hidden = false;
    }
    root.querySelectorAll('.km-f__info[data-tipp-fuer]').forEach(function (knopf) {
      var feld = document.getElementById(knopf.getAttribute('data-tipp-fuer')); if (!feld) return;
      knopf.addEventListener('click', function (e) { e.preventDefault(); var auf = feld.hidden; feld.hidden = !auf; knopf.setAttribute('aria-expanded', auf ? 'true' : 'false'); knopf.classList.toggle('is-auf', auf); });
    });

    /* ================= Skizzen-Upload ================= */
    var datei = form.elements['skizze_datei'];
    var uploadStatus = root.querySelector('[data-upload-status]');
    if (datei) {
      datei.addEventListener('change', function () {
        var f = datei.files && datei.files[0];
        setWert('skizze_url', ''); setWert('skizze_name', '');
        if (!f) { if (uploadStatus) uploadStatus.textContent = 'Noch keine Datei'; update(); return; }
        var maxB = (R.skizze.max_mb || 10) * 1024 * 1024;
        if (f.size > maxB) { if (uploadStatus) uploadStatus.textContent = 'Datei zu groß (max. ' + (R.skizze.max_mb || 10) + ' MB).'; datei.value = ''; update(); return; }
        if (R.skizze.typen && R.skizze.typen.indexOf(f.type) < 0) { if (uploadStatus) uploadStatus.textContent = 'Bitte PDF, JPG oder PNG.'; datei.value = ''; update(); return; }
        if (uploadStatus) uploadStatus.textContent = 'Wird hochgeladen …';
        var fd = new FormData();
        fd.append('datei', f, f.name);
        fd.append('produkt', CTX.productTitle || '');
        fetch(R.skizze.upload_endpoint, { method: 'POST', body: fd })
          .then(function (res) { return res.json().catch(function () { return {}; }).then(function (j) { return { ok: res.ok, body: j }; }); })
          .then(function (a) {
            if (!a.ok || !a.body || a.body.ok !== true || !a.body.url) throw new Error(a.body && a.body.grund ? a.body.grund : '');
            setWert('skizze_url', a.body.url); setWert('skizze_name', f.name);
            if (uploadStatus) uploadStatus.textContent = 'Hochgeladen: ' + f.name;
            update();
          })
          .catch(function (e) {
            if (uploadStatus) uploadStatus.textContent = 'Upload fehlgeschlagen' + (e.message ? ': ' + e.message : '') + '. Bitte noch einmal versuchen oder die Skizze per E-Mail schicken.';
            datei.value = ''; update();
          });
      });
    }

    /* ================= Warenkorb ================= */
    function msg(t, ok) { if (els.msg) { els.msg.textContent = t; els.msg.className = 'km-msg ' + (ok ? 'is-ok' : 'is-err'); } }
    if (els.add) els.add.addEventListener('click', function () {
      var r = update();
      if (!r.ok) {
        var f = r.s.fehlt;
        if (f && f.length) {
          msg('Bitte treffen Sie noch eine Auswahl: ' + f.map(function (x) { return x.label; }).join(', ') + '.', false);
          var ziel = root.querySelector('[data-step="' + f[0].schritt + '"]');
          if (ziel) { var t = ziel.querySelector('.km-step__toggle'); if (t && t.getAttribute('aria-expanded') === 'false') t.click(); ziel.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
        } else {
          msg(r.fehler.indexOf('skizze') >= 0 ? 'Bitte laden Sie die Skizze Ihrer Sonderform hoch.' : 'Bitte prüfen Sie die Maße.', false);
          var zielM = root.querySelector('[data-step="masse"]');
          if (zielM) { var tm = zielM.querySelector('.km-step__toggle'); if (tm && tm.getAttribute('aria-expanded') === 'false') tm.click(); zielM.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
        }
        return;
      }
      var items = [{ id: CTX.variantId, quantity: 1, properties: properties(r.s, r.p) }];
      els.add.setAttribute('aria-busy', 'true'); msg('', true);
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (res) { return res.json().then(function (j) { if (!res.ok) throw new Error(j.description || j.message || 'Fehler'); return j; }); })
        .then(function () { msg('Konfiguration im Warenkorb.', true); window.location.href = '/cart'; })
        .catch(function (e) { msg('Der Artikel konnte nicht in den Warenkorb gelegt werden: ' + e.message, false); })
        .then(function () { els.add.removeAttribute('aria-busy'); });
    });

    /* ================= Angebotsanfrage (Modal) ================= */
    (function anfrageInit() {
      var knopf = els.quote;
      var modal = document.getElementById('km-modal-' + sid);
      var anfrage = document.getElementById('km-quoteform-' + sid);
      if (!knopf || !modal || !anfrage) return;
      var zusammenfassung = document.getElementById('km-modal-konfig-' + sid);
      var fehlerfeld = document.getElementById('km-quoteerr-' + sid);
      var fertig = document.getElementById('km-quotedone-' + sid);
      var lieferBlock = document.getElementById('km-liefer-' + sid);
      var geoeffnetUm = 0, zuletztFokussiert = null, laeuft = false;

      function uebersichtHtml(r) {
        var s = r.s, p = r.p, z = [];
        z.push(R.material.label + ': ' + s.mat.label);
        if (s.mat.farbe && s.f) z.push(R.farbe.label + ': ' + farbText(s));
        if (R.glas && s.glaso) z.push(R.glas.label + ': ' + s.glaso.label);
        z.push(R.befestigung.label + ': ' + s.bef.label);
        z.push(R.geometrie.label + ': ' + s.geo.label);
        z.push(R.hoehe.label + ': ' + s.h + ' mm');
        if (s.geo.skizze) { z.push(R.laengen.gesamt_label + ': ' + s.lg + ' mm'); z.push('Skizze: ' + (s.skn || 'hochgeladen')); }
        else for (var i = 0; i < s.geo.laengen; i++) z.push(R.laengen.labels[i] + ': ' + [s.l1, s.l2, s.l3][i] + ' mm');
        z.push(R.handlauf.label + ': ' + s.hlo.label);
        z.push(R.masse.e.label + ': ' + s.e + ' mm · ' + R.masse.z.label + ': ' + s.z + ' mm · ' + R.masse.y.label + ': ' + s.y + ' mm');
        z.push(R.sets.label + ': ' + s.set.label);
        var fuss = fmtM(p.flaeche, 2) + ' m² · ' + fmt(r.total) + ' inkl. MwSt.';
        return z.map(esc).join('<br>') + '<br><br><strong>' + esc(fuss) + '</strong>';
      }
      function fokussierbare() { return modal.querySelectorAll('button:not([disabled]),a[href],input:not([type="hidden"]),select,textarea'); }
      function beiTaste(e) {
        if (e.key === 'Escape') { schliessen(); return; }
        if (e.key !== 'Tab') return;
        var f = fokussierbare(); if (!f.length) return;
        var erstes = f[0], letztes = f[f.length - 1];
        if (e.shiftKey && document.activeElement === erstes) { e.preventDefault(); letztes.focus(); }
        else if (!e.shiftKey && document.activeElement === letztes) { e.preventDefault(); erstes.focus(); }
      }
      function oeffnen() {
        var r = update();
        if (!r.ok) { msg(r.fehler.indexOf('skizze') >= 0 ? 'Bitte laden Sie zuerst die Skizze Ihrer Sonderform hoch.' : 'Bitte prüfen Sie Auswahl und Maße, bevor Sie ein Angebot anfordern.', false); return; }
        zusammenfassung.innerHTML = uebersichtHtml(r);
        var bem = wert('bemerkung'); if (bem && !anfrage.elements['bemerkung'].value) anfrage.elements['bemerkung'].value = bem;
        if (CTX.country) { var landFeld = anfrage.elements['land']; for (var i = 0; i < landFeld.options.length; i++) if (landFeld.options[i].value === CTX.country) { landFeld.value = CTX.country; break; } }
        ustidSichtbarkeit();
        anfrage.hidden = false; fertig.hidden = true; fehlerfeld.hidden = true; modal.hidden = false;
        document.body.classList.add('km-modal-open'); document.addEventListener('keydown', beiTaste);
        geoeffnetUm = Date.now(); zuletztFokussiert = document.activeElement;
        var erstesFeld = anfrage.querySelector('input[name="vorname"]'); if (erstesFeld) erstesFeld.focus();
      }
      function schliessen() {
        modal.hidden = true; document.body.classList.remove('km-modal-open'); document.removeEventListener('keydown', beiTaste);
        if (zuletztFokussiert && zuletztFokussiert.focus) zuletztFokussiert.focus();
      }
      function fehler(text) { fehlerfeld.textContent = text; fehlerfeld.hidden = false; fehlerfeld.scrollIntoView({ block: 'nearest' }); }
      function adresse() {
        var fehlend = [];
        ['vorname', 'nachname', 'strasse', 'plz', 'ort', 'email'].forEach(function (n) { var el = anfrage.elements[n]; var leer = !String(el.value || '').trim(); el.setAttribute('aria-invalid', leer ? 'true' : 'false'); if (leer) fehlend.push(n); });
        if (fehlend.length) { fehler('Bitte füllen Sie alle Pflichtfelder aus.'); anfrage.elements[fehlend[0]].focus(); return null; }
        var mail = String(anfrage.elements['email'].value).trim();
        if (!/^[^@\s]+@[^@\s]+\.[a-z]{2,}$/i.test(mail)) { anfrage.elements['email'].setAttribute('aria-invalid', 'true'); fehler('Diese E-Mail-Adresse sieht nicht richtig aus. Ohne sie können wir Ihnen das Angebot nicht schicken.'); anfrage.elements['email'].focus(); return null; }
        // Kein Einwilligungs-Haken mehr (Martin 16.09.2026) - Datenschutzhinweis steht unter dem
        // Formular. dsgvo bleibt in der Nutzlast true (n8n bricht ohne das Feld ab), anrede entfaellt
        // (der Workflow gruesst dann mit "Guten Tag Vorname Nachname").
        function t(n) { var el = anfrage.elements[n]; return el ? String(el.value || '').trim() : ''; }
        return { firma: t('firma'), ustid: t('ustid').toUpperCase().replace(/[\s.\-]/g, ''), vorname: t('vorname'), nachname: t('nachname'), strasse: t('strasse'), plz: t('plz'), ort: t('ort'), land: t('land') || 'DE', email: mail, telefon: t('telefon'), bemerkung: t('bemerkung') };
      }
      function lieferanschrift() {
        var an = anfrage.elements['abw_lieferung']; if (!an || !an.checked) return { ok: true, wert: null };
        var fehlend = [];
        ['l_person', 'l_telefon', 'l_strasse', 'l_plz', 'l_ort'].forEach(function (n) { var el = anfrage.elements[n]; if (!el) return; var leer = !String(el.value || '').trim(); el.setAttribute('aria-invalid', leer ? 'true' : 'false'); if (leer) fehlend.push(n); });
        if (fehlend.length) { fehler('Bitte füllen Sie die Lieferanschrift vollständig aus. Ansprechpartner und Telefon brauchen wir für die Avisierung durch die Spedition.'); anfrage.elements[fehlend[0]].focus(); return { ok: false, wert: null }; }
        function lt(n) { var el = anfrage.elements[n]; return el ? String(el.value || '').trim() : ''; }
        return { ok: true, wert: { firma: lt('l_firma'), person: lt('l_person'), telefon: lt('l_telefon'), strasse: lt('l_strasse'), plz: lt('l_plz'), ort: lt('l_ort'), land: lt('l_land') || 'DE' } };
      }
      var abwFeld = anfrage.elements['abw_lieferung'];
      if (abwFeld && lieferBlock) abwFeld.addEventListener('change', function () {
        lieferBlock.hidden = !abwFeld.checked;
        if (!abwFeld.checked) ['l_firma', 'l_person', 'l_telefon', 'l_strasse', 'l_plz', 'l_ort'].forEach(function (n) { var el = anfrage.elements[n]; if (el) { el.value = ''; el.setAttribute('aria-invalid', 'false'); } });
        else { var erstes = anfrage.elements['l_person']; if (erstes) erstes.focus(); }
      });
      function ustidSichtbarkeit() {
        var feld = anfrage.querySelector('.km-fld--ustid'), landFeld = anfrage.elements['land']; if (!feld || !landFeld) return;
        var auslaendisch = landFeld.value && landFeld.value !== 'DE';
        feld.hidden = !auslaendisch; if (!auslaendisch && anfrage.elements['ustid']) anfrage.elements['ustid'].value = '';
      }
      if (anfrage.elements['land']) anfrage.elements['land'].addEventListener('change', ustidSichtbarkeit);
      knopf.addEventListener('click', oeffnen);
      modal.querySelectorAll('[data-km-close]').forEach(function (b) { b.addEventListener('click', schliessen); });
      anfrage.addEventListener('submit', function (e) {
        e.preventDefault(); if (laeuft) return; fehlerfeld.hidden = true;
        var kunde = adresse(); if (!kunde) return;
        var liefer = lieferanschrift(); if (!liefer.ok) return;
        if (!CTX.quoteEndpoint) { fehler('Die Anfrage kann gerade nicht übermittelt werden. Bitte rufen Sie uns an: +49 9672 9269 110'); return; }
        var r = update(); if (!r.ok) { fehler('Bitte prüfen Sie Ihre Konfiguration.'); return; }
        var s = r.s;
        var absenden = anfrage.querySelector('button[type="submit"]');
        laeuft = true; absenden.setAttribute('aria-busy', 'true');
        var nutzlast = {
          typ: 'gelaender', produkt_id: String(CTX.productId || ''), produkt_titel: CTX.productTitle, produkt_url: CTX.productUrl, sku: CTX.sku || '',
          hp: String(anfrage.elements['hp'].value || ''), ms: Date.now() - geoeffnetUm, dsgvo: true, kunde: kunde, lieferung: liefer.wert,
          konfig: konfig(s)
        };
        fetch(CTX.quoteEndpoint, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(nutzlast) })
          .then(function (res) { return res.json().catch(function () { return {}; }).then(function (j) { return { ok: res.ok, body: j }; }); })
          .then(function (a) { if (!a.ok || a.body.ok !== true) throw new Error(a.body && a.body.grund ? a.body.grund : ''); anfrage.hidden = true; fertig.hidden = false; fertig.querySelector('button').focus(); })
          .catch(function (e) { fehler((e.message ? e.message + ' ' : 'Die Anfrage konnte nicht übermittelt werden. ') + 'Bitte versuchen Sie es noch einmal oder rufen Sie uns an: +49 9672 9269 110'); })
          .then(function () { laeuft = false; absenden.removeAttribute('aria-busy'); });
      });
    })();

    /* ================= Deep-Link lesen, Events, Start ================= */
    (function restore() {
      var m = location.hash.match(/konf=([A-Za-z0-9+\/]+)/) || location.search.match(/konf=([A-Za-z0-9+\/]+)/);
      if (!m) return;
      var c = decode(m[1]); if (!c || c.t !== 'g') return;
      setWert('material', c.m); setWert('glas', c.glas); setWert('farbe', c.f); setWert('farbe_wunsch', c.fw); setWert('befestigung', c.bf); setWert('geometrie', c.g);
      setWert('hoehe', c.h); setWert('l1', c.l1); setWert('l2', c.l2); setWert('l3', c.l3); setWert('lg', c.lg);
      setWert('handlauf', c.hl); setWert('e', c.e); setWert('z', c.z); setWert('y', c.y); setWert('set', c.st); setWert('bemerkung', c.bm);
      if (c.sk) { setWert('skizze_url', c.sk); setWert('skizze_name', c.skn || ''); if (uploadStatus) uploadStatus.textContent = 'Hochgeladen: ' + (c.skn || 'Skizze'); }
      beruehrt.masse = true; beruehrt.montage = true;
    })();
    form.addEventListener('input', function (e) { nutzerAendert = true; var st = FELD_SCHRITT[e.target && e.target.name]; if (st) beruehrt[st] = true; update(); });
    form.addEventListener('change', function (e) { nutzerAendert = true; var st = FELD_SCHRITT[e.target && e.target.name]; if (st) beruehrt[st] = true; update(); });
    root.querySelectorAll('.km-f__step').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = form.elements[btn.dataset.for]; if (!input) return;
        var step = Number(btn.dataset.step);
        input.value = clamp(Number(input.value) + step, Number(input.min), Number(input.max));
        beruehrt.masse = true; update();
      });
    });
    ['hoehe', 'l1', 'l2', 'l3', 'lg', 'e', 'z', 'y'].forEach(function (n) {
      var el = form.elements[n]; if (!el) return;
      el.addEventListener('blur', function () { if (this.value === '') return; this.value = clamp(this.value, Number(this.min), Number(this.max)); update(); });
    });
    ['e', 'z', 'y'].forEach(function (n) {
      var el = form.elements[n]; if (!el) return;
      el.addEventListener('focus', function () { beruehrt.montage = true; update(); skizzeZeigen(n); });
    });
    schritte.forEach(function (s) { aufklappen(s, false, false); });
    if (schritte[0]) aufklappen(schritte[0], true, false);
    update();
    renderThumbsVerstecken();
    // Beim Laden bleibt das Produktfoto stehen; das Rendering erscheint mit der ersten
    // Eingabe im Konfigurator (Schritt öffnen, Form oder Befestigung wählen).
    galerieBereit = true; aktuellerKey = null;
  }

  document.querySelectorAll('.km-gelaender[data-section-id]').forEach(init);
})();
